import React from 'react';
import RegisterState, { ChipDetails } from './RegisterStateV2';

export const stepsInOrderV2 = ['chip', 'email', 'pet', 'contact', 'rescueCollar', 'upgrade', 'success'] as const;
export type RegisterChipStep = (typeof stepsInOrderV2)[number];

/**
 * The merged success screen folds the upgrade step into the confirmation, so the flow becomes
 * four steps and a confirmation instead of five and a confirmation. The rescue collar question is
 * walked only while its flag is on.
 *
 * The canonical array above keeps every step so `RegisterChipStep` includes them all; this returns
 * the order actually being walked.
 */
export function activeStepsInOrder(
  mergedSuccessEnabled: boolean,
  rescueCollarQuestionEnabled: boolean,
): readonly RegisterChipStep[] {
  return stepsInOrderV2.filter(
    (step) => (step !== 'upgrade' || !mergedSuccessEnabled) && (step !== 'rescueCollar' || rescueCollarQuestionEnabled),
  );
}

interface RegisterChipContextValue {
  currentUserIsReseller: boolean;
  onStepFinished: (step: RegisterChipStep) => void;
  registerState: RegisterState;
  setChipDetails: (chipDetails: ChipDetails) => void;
  setPetId: (petId: string) => void;
  setChipId: (chipId: string) => void;
  setPrimaryEmail: (primaryEmail: string) => void;
  setRescueCollarClaimed: (claimed: boolean) => void;
  registerChipAddEmail: (chipId: string) => Promise<void>;
}

const RegisterChipContextV2 = React.createContext<RegisterChipContextValue>({
  currentUserIsReseller: false,
  onStepFinished: () => {},
  registerState: {},
  setChipDetails: () => {},
  setPetId: () => {},
  setChipId: () => {},
  setPrimaryEmail: () => {},
  setRescueCollarClaimed: () => {},
  registerChipAddEmail: async () => {
    throw new Error('Not implemented');
  },
});
export default RegisterChipContextV2;
